import React from 'react'

const Logo = () => {
    return (
        <h1 className='header__logo'>
            <a href="/">
                <em></em>
                <span>camping<br /><i>youtube</i></span>
            </a>
        </h1>
    )
}

export default Logo